export class DataBoxAction {
  title: string | Function;
  action: string | Function;
  icon: string;
  color: string;
  hide: boolean | Function;

  constructor( object: any = {} ){
    this.title = object.title ? object.title : undefined;
    this.action = object.action ? object.action : undefined;
    this.icon = object.icon ? object.icon : undefined;
    this.color = object.color ? object.color : undefined;
    this.hide = object.hide ? object.hide : false;
  }
}